import styled from "styled-components"
import { device } from "breakpoints"
import AvenueImg from "components/AvenueImg"
import { Carousel } from "../Carousel"
import {
  EmblaComponent,
  SlidesContainer,
  Controls,
  Dots,
  NextButton,
  PreviousButton,
} from "../Carousel/style"
import { MainColumn } from "components/MainColumn"
import { getGradient } from "helpers/getGradient"
import { getGradientText } from "helpers/getGradientText"

export const TestimonialCarouselContainer = styled(MainColumn)`
  position: relative;
  width: calc(100% - 30px);
  margin-left: 30px;
  margin-bottom: 117px;

  @media ${device.desktop} {
    flex-direction: row;
    margin: 0 auto;
    width: ${props => `calc(100% - 2*${props.theme.desktopGutter}px)`};
    max-width: ${props => `${props.theme.mainMaxWidth}px`};
    margin-bottom: 91px;
  }

  @media ${device.large} {
    margin-bottom: 155px;
  }
  :before,
  :after {
    background-image: ${getGradient()};
    content: "";
    display: block;
    height: 1px;
    width: 100vw;
    left: calc(50% - 15px);
    position: absolute;
    right: 0;
    transform-origin: -50%;
    z-index: -1;

    @media ${device.desktop} {
      width: calc(100vw + 30px);
    }
  }

  :before {
    bottom: -60px;
    transform: skewY(0deg) translateX(-50%);

    @media ${device.tablet} {
      transform: skewY(-4deg) translateX(-50%);
    }

    @media ${device.desktop} {
      bottom: -30px;
      transform: skewY(-6deg) translateX(-50%);
    }

    @media ${device.large} {
      bottom: -60px;
    }

    @media ${device.big} {
      bottom: -150px;
    }
  }

  :after {
    bottom: -90px;
    transform: skewY(-14deg) translateX(-50%);

    @media ${device.tablet} {
      bottom: -110px;
      transform: skewY(-12deg) translateX(-50%);
    }

    @media ${device.desktop} {
      bottom: -130px;
      transform: skewY(-17deg) translateX(-50%);
    }

    @media ${device.large} {
      bottom: -160px;
    }

    @media ${device.big} {
      bottom: -280px;
    }
  }
`

export const TextWrapper = styled.div`
  order: 1;
  padding-bottom: 58px;
  padding-right: 20px;
  height: 339px;

  @media (min-width: 500px) {
    height: 280px;
  }

  @media ${device.tablet} {
    padding-right: 50px;
    height: 220px;
  }

  @media ${device.desktop} {
    padding-right: 60px;
    padding-bottom: 115px;
    height: 400px;
  }

  @media ${device.large} {
    padding-right: 80px;
    height: 467px;
  }

  h4 {
    font-size: 10px;
    color: #6f749b;
    letter-spacing: 4.29px;
    margin-bottom: 10px;

    @media ${device.desktop} {
      font-size: 12px;
      margin-bottom: 25px;
    }
    @media ${device.large} {
      margin-bottom: 40px;
    }
  }

  blockquote {
    line-height: 137%;
    font-size: 21px;
    ${props => getGradientText("study")}
    width:100%;

    @media (min-width: 375px) {
      font-size: 23px;
    }

    @media (min-width: 460px) {
      font-size: 24px;
    }
    /* color: purple; */
    margin-bottom: 27px;
    @media ${device.desktop} {
      font-size: 28px;
    }
    @media ${device.large} {
      margin-bottom: 35px;
      font-size: 36px;
    }
  }

  p {
    font-size: 14px;
    color: #6f7676;
    width: 100%;

    @media ${device.desktop} {
      font-size: 16px;
    }

    span.name {
      color: #a5368c;
      font-weight: 600;
      margin-right: 25px;
      position: relative;

      @media ${device.desktop} {
        margin-right: 30px;
      }

      :before {
        position: absolute;
        top: 55%;
        right: -8px;
        transform: translate3d(100%, -50%, 0);
        height: 1px;
        background: #727a7a;
        opacity: 0.6;
        width: 13px;
        content: "";

        @media ${device.desktop} {
          right: -9px;
          width: 16px;
        }
      }
    }
  }
  @media ${device.desktop} {
    order: 0;
    width: 50%;
  }

  .transitionGroup {
    position: relative;
    width: 100%;
  }
`

export const AnimatedText = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const CarouselsContainer = styled.div`
  display: flex;

  @media ${device.desktop} {
    position: absolute;
    top: 0;
    left: 0;
    width: 112%;
    height: 100%;
    padding-left: calc(50% + 20px);
    overflow: hidden;
  }

  @media ${device.large} {
    width: 118%;
  }
`
export const CarouselsWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  width: 100%;

  @media ${device.desktop} {
    margin-bottom: 0;
  }
`
export const TestimonialCarouselMain = styled(Carousel)`
  width: 52%;
  margin-right: 15px;

  @media ${device.desktop} {
    width: 50%;
    margin-right: 45px;
  }

  ${SlidesContainer} {
    width: 100%;
  }
  ${Controls} {
    flex-direction: row;
    position: absolute;
    left: 0;
    bottom: 0;

    @media ${device.desktop} {
      bottom: 3px;
    }
  }

  ${EmblaComponent} {
    clip-path: inset(0 1px 0 1px);
  }

  ${NextButton} {
    background-image: ${getGradient()};
    height: 42px;
    width: 42px;

    @media ${device.desktop} {
      height: 48px;
      width: 48px;
    }
  }

  ${PreviousButton} {
    margin-right: 10px;
  }

  ${Dots} {
    order: 2;
    margin-left: 10px;

    @media ${device.desktop} {
      margin-left: 30px;
    }

    ${props =>
      props.hasTwo &&
      `
    button:nth-of-type(3),button:nth-of-type(4) {
      transform:translateX(-40px);
    }
    `};
  }
`

export const TestimonialCarouselSecondary = styled(TestimonialCarouselMain)`
  margin-right: 0px !important;
  width: auto;
  flex-grow: 1;
  height: 53%;
  height: ${props => props.hasTwo && "70%"};
  /* margin-top: ${props => props.hasTwo && "65px"}; */
  /* margin-left: -3px; */

  @media ${device.desktop} {
    /* margin-top: ${props => props.hasTwo && "0px"}; */
    height: ${props => props.hasTwo && "70%"};

    clip-path: ${props =>
      props.hasTwo
        ? null
        : `polygon(
      44% 100%,
      56% 100%,
      56% 0,
      100% 0,
      100% 100%,
      100% 100%,
      0 100%,
      0 0,
      44% 0
    )`};
  }

  ${EmblaComponent} {
    position: relative;
    clip-path: inset(0 0 0 1px);
    height: ${props => props.hasTwo && "100%"};

    @media ${device.desktop} {
      clip-path: inset(0 1px 0 1px);
    }

    :before {
      content: "";
      position: absolute;
      top: 0;
      left: 70%;
      width: 15px;
      height: 100%;
      transform: translateX(-50%);
      z-index: 2;
      background: white;

      ${props =>
        props.hasTwo &&
        `
      transform:none;
      width:200px;
      left:80%;
      `};

      @media ${device.desktop} {
        display: none;
        left: 50%;
        width: 40px;

        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
          /* IE10+ CSS styles go here */
          display: block !important;
        }
      }

      @media ${device.large} {
        ${props =>
          props.hasTwo &&
          `
          
          display: block;
      transform:none;
      width:300px !important;
      left:68%;

      `};
      }
    }
  }
`

export const CarouselSlide = styled.div`
  padding-top: 130%;
  width: 100%;
`
export const CarouselSlideSmall = styled(CarouselSlide)`
  padding-top: 115.8%;
  cursor: pointer;
  display: ${props => props.hide && "none"};

  img {
    object-position:${props => props.hasTwo && '64% 50%'} !important;
  }
`

export const SlideImg = styled(AvenueImg)`
  position: absolute !important;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  /* width: 101%;
  height: 101%; */
  width: 100%;
  height: 100%;
  /* position:absolute;
  top:0;
  left:0;
  width: 100%;
  height:100%; */
`
